<template>
  <div class="top-header">
    <div class="title">{{ $i18n.platformTitle }}</div>
    <div class="user-area">
      <el-button size="mini" :type="$langStore.currentLang==='zh'?'primary':''" @click="$langStore.currentLang='zh'">中文</el-button>
      <el-button size="mini" :type="$langStore.currentLang==='en'?'primary':''" @click="$langStore.currentLang='en'">English</el-button>

      <span>{{ userName }}</span>
      <button @click="handleLogout">{{ $i18n.logout }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  computed: {
    userName() {
      return this.$store.state.user.userName || '未登录'
    }
  },
  methods: {
    handleLogout() {
      this.$store.commit('user/CLEAR_USER')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.top-header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.user-area {
  display: flex;
  align-items: center;
  gap: 12px;
}
button {
  padding: 6px 14px;
  cursor: pointer;
}
</style>
